import { render, staticRenderFns } from "./facial.vue?vue&type=template&id=a7ffe6e6&scoped=true&"
import script from "./facial.vue?vue&type=script&lang=js&"
export * from "./facial.vue?vue&type=script&lang=js&"
import style0 from "./facial.vue?vue&type=style&index=0&id=a7ffe6e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ffe6e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7ffe6e6')) {
      api.createRecord('a7ffe6e6', component.options)
    } else {
      api.reload('a7ffe6e6', component.options)
    }
    module.hot.accept("./facial.vue?vue&type=template&id=a7ffe6e6&scoped=true&", function () {
      api.rerender('a7ffe6e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menopauseovary/facial.vue"
export default component.exports